export { default } from '@esentai/core/features/beacons/api';
